/** The shop payment step piece, standard look over its behavior half. */
import { ShopPaymentStepView } from './ShopPaymentStepView';
import { useShopPaymentStep, type ShopPaymentStepInput } from './useShopPaymentStep';

export { ShopPaymentStepView, useShopPaymentStep };

export function ShopPaymentStep(props: ShopPaymentStepInput) {
  return <ShopPaymentStepView {...useShopPaymentStep(props)} />;
}
